import { isExactEmailAllowed } from './allowedEmails';

export function getAllowedEmailDomains(): string[] {
  const raw = import.meta.env.VITE_ALLOWED_EMAIL_DOMAINS ?? '';
  return raw
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

// Login passes if the email's domain is in the env-driven allow-list OR
// the exact email is in the committed ALLOWED_EMAILS escape hatch (auth
// polish Item 1). Mirrors the server-side check in
// server/modules/auth/middleware.ts.
export function isAllowedEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  if (isExactEmailAllowed(email)) return true;
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  return getAllowedEmailDomains().includes(domain);
}
